/**
 * Video Modal Functionality
 * Opens videos in a modal for team members and podcast episodes
 * Uses WordPress oEmbed to generate video embeds server-side
 */

document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  const modal = document.getElementById('video-modal');
  const videoContainer = document.getElementById('video-container');
  const closeBtn = modal ? modal.querySelector('.video-modal-close') : null;
  const overlay = modal ? modal.querySelector('.video-modal-overlay') : null;

  if (!modal) return;

  // Open video modal
  document.addEventListener('click', function (e) {
    const teamMember = e.target.closest('.team-member');
    const podcastCard = e.target.closest('.podcast-card__image-wrapper');

    if (!teamMember && !podcastCard) return;

    const element = teamMember || podcastCard;
    const videoEmbed = element.getAttribute('data-video-embed');
    if (!videoEmbed) return;

    e.preventDefault();
    openVideoModal(videoEmbed);
  });

  // Close modal on button click
  if (closeBtn) {
    closeBtn.addEventListener('click', closeVideoModal);
  }

  // Close modal on overlay click
  if (overlay) {
    overlay.addEventListener('click', closeVideoModal);
  }

  // Close modal on ESC key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.style.display === 'flex') {
      closeVideoModal();
    }
  });

  function openVideoModal(embedCode) {
    // WordPress oEmbed has already generated the embed HTML for us
    videoContainer.innerHTML = embedCode;
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function closeVideoModal() {
    modal.style.display = 'none';
    videoContainer.innerHTML = '';
    document.body.style.overflow = '';
  }

});
